"use client";
import { jsxs as t, Fragment as _, jsx as e } from "react/jsx-runtime";
import { useLocaleText as C, Group as n, Paragraph as i, rem as P, Link as v, Icon as y, TextLink as N, sharedHandler as M } from "@ingeniorforeningen/figurine-core";
import { forwardRef as $ } from "react";
import '../../../assets/PersonCardContent.css';const j = "_container_csl4f_2", z = "_image_csl4f_23", D = "_contactLink_csl4f_31", R = {
  container: j,
  image: z,
  contactLink: D
}, r = $((u, h) => {
  const { name: p, title: c, description: o, link: a, mail: s, phone: d, secondaryPhone: l } = u, g = C(), k = [
    { value: s, icon: "Mail", directLink: `mailto:${s}` },
    { value: d, icon: "Phone", directLink: `tel:${d}` },
    { value: l, icon: "DeviceMobile", directLink: `tel:${l}` }
  ];
  return /* @__PURE__ */ t(_, { children: [
    /* @__PURE__ */ t(n, { spacing: "lg", direction: "column", ref: h, children: [
      /* @__PURE__ */ t(n, { spacing: "xs", direction: "column", children: [
        /* @__PURE__ */ e(i, { text: p, strong: !0, condensed: !0, variant: "dark" }),
        c && /* @__PURE__ */ e(i, { text: c, variant: "neutral", size: "caption", medium: !0, condensed: !0 })
      ] }),
      /* @__PURE__ */ t(n, { spacing: "lg", direction: "column", children: [
        o && /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(i, { text: o, condensed: !0 }) }),
        /* @__PURE__ */ e(n, { direction: "column", spacing: P("8px"), children: k.map(
          ({ value: m, icon: x, directLink: f }, L) => m && /* @__PURE__ */ e(n, { children: /* @__PURE__ */ t(v, { href: f, className: R.contactLink, children: [
            /* @__PURE__ */ e(y, { name: x, color: "dark", size: "small" }),
            /* @__PURE__ */ e(i, { text: m, condensed: !0, medium: !0, variant: "dark" })
          ] }) }, L)
        ) })
      ] })
    ] }),
    a && /* @__PURE__ */ e(
      N,
      {
        href: a,
        text: g.readMore,
        variant: "cta",
        iconColor: "dark",
        icon: "ChevronRight",
        iconPlacement: "right"
      }
    )
  ] });
});
r.displayName = "PersonCardContent";
const T = M(r);
T.displayName = r.displayName;
export {
  R as P,
  r as _PersonCardContent,
  T as default
};
